import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'

import '@/plugins/vuetify'
import '@/plugins/veevalidate'
import '@/plugins/moment'
import '@/plugins/gallery'
import '@/plugins/applicationInsights'

import {
  abilitiesPlugin
} from '@casl/vue'
import ability from '@/plugins/abilityPlugIn'
//import defineAbilitiesFor from '@/plugins/ability'

//ability.update(defineAbilitiesFor(''))
Vue.use(abilitiesPlugin, ability)

Vue.prototype.appName = 'ahoj'

Vue.prototype.$reverseText = function (propertyName) {
  this[propertyName] = this[propertyName]
    .split('')
    .reverse()
    .join('')
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')